export default "__VITE_ASSET__BlAIS1R1__"